import {FC, ReactNode} from 'react';
import {Box} from '@mui/material';
import FlatInput, {FlatInputProps} from '../flat-input/flat-input';

interface ReadOnlyTextFieldProps extends Omit<FlatInputProps, 'InputProps'> {
  startAdornment?: ReactNode | any;
  endAdornment?: ReactNode | any;
  endExternalAdornment?: ReactNode | any;
}

/**
 * Read only text field.
 */
export const ReadOnlyTextField: FC<ReadOnlyTextFieldProps> = ({
  label,
  value,
  className,
  multiline,
  minRows,
  maxRows,
  rows,
  startAdornment,
  endAdornment,
  endExternalAdornment,
  disabledTooltip,
  sx,
}: ReadOnlyTextFieldProps) => {
  // Text field
  const TextField: ReactNode = (
    <FlatInput
      label={label}
      value={value}
      InputProps={{
        startAdornment,
        endAdornment,
      }}
      multiline={multiline}
      rows={rows}
      minRows={minRows}
      maxRows={maxRows}
      required
      disabled
      disabledTooltip={disabledTooltip}
    />
  );

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'flex-end',
        width: '100%',
        ...sx,
      }}
      className={className}
    >
      {TextField}
      {endExternalAdornment && (
        <Box sx={{marginLeft: '8px', height: '42px'}}> {endExternalAdornment}</Box>
      )}
    </Box>
  );
};
